import { Icon } from '@fluentui/react';
import Moment from 'moment';
import { useTranslation } from "react-i18next";
import AnnotationColorBox from './AnnotationColorBox';
const ColumnsFinding = () =>{
    const paddingHeader = "15px 15px";
    const paddingChild = "0px 15px 0px 15px";
    const widthStyle = "20vw";
    const [t, i18n] = useTranslation();
    return [
      {
        id: t("finding.name"),
        style: {width: widthStyle, padding: paddingChild,boxSizing:'border-box' },
        headerStyle: {padding:paddingHeader, textAlign: "left",boxSizing:'border-box', width: widthStyle},
        headerClass:"break-word",
        classChildName:
            "break-word",
        header: () => (
          <>{t("modality.column.name")}</>
        ),
        accessor: t("finding.name"),
        accessorKey: t("finding.name"),
        show: true,
        cell: (info) =>  <>
            <div className="user-sub-heading">{info.row.original.name}</div>
      </>
      },
      {
        id: t("finding.color"),
        style: {width: widthStyle, padding: paddingChild,boxSizing:'border-box' },
        headerStyle: {padding:paddingHeader, textAlign: "left",boxSizing:'border-box', width: widthStyle},
        headerClass:"break-word",
        classChildName:
            "break-word",
        header: () => (
          <>{t("finding.color")}</>
        ),
        accessor: t("finding.color"),
        accessorKey: t("finding.color"),
        show: true,
        cell: (info) =>  <>
             {info.row.original.color}
      </>
      }
    ];
  };
export default ColumnsFinding;
